'use strict';

angular.module('mean.bids').controller('BidOldReviewController', ['$scope', 'MeanUser', 'Global', '$q', 'Bids', '$filter', '$sce', 'toaster', 'NotifyService', 'BidOldReview', 'CompanyFactors', '$location', 'tradeCodeService', 'taskTotalsService', 'Projects', 'ProjectBids', 'projectBidService', 'userService', 'TradeBids', 'builderService',
  function($scope, MeanUser, Global, $q, Bids, $filter, $sce, toaster, NotifyService, BidOldReview, CompanyFactors, $location, tradeCodeService, taskTotalsService, Projects, ProjectBids, projectBidService, userService, TradeBids, builderService) {
    $scope.global = Global;

    $scope.user = MeanUser.user;
    $scope.my_roles = MeanUser.user.roles;

    $scope.is_builder = builderService.isBuilder($scope.user.username);

    $scope.expanded_table = 'true';
    $scope.bid_total_labor = 0;
    $scope.bid_total_materials = 0;
    $scope.bid_total_equipment = 0;
    $scope.bid_total = 0;
    $scope.bid_general_liability = 0;
    $scope.trade_totals = [];
    $scope.current_trade_selection = {}
    $scope.current_trade_selection.trade = 'Total';
    $scope.bid_tasks = [];

    $scope.revisions = [];
    $scope.current_trade_costs = {};
    $scope.original_bid_list = [];
    $scope.original_costs = {};
    $scope.original_inclusions = [];
    $scope.original_exclusions = [];
    $scope.original_overrides = [];
    $scope.original_extra_liability = [];

    $scope.materials = [];
    $scope.equipment = [];

    $scope.MaterialTotal = 0;
    $scope.EquipmentTotal = 0;

    $scope.sortType = ['trade', 'note', 'name', 'plan_code', 'task_code'];
    $scope.sortReverse = false;
    $scope.filtered_menu_items = ['Specs', 'Materials', 'Total Materials'];

    var data = [];

    $scope.toggleTableColumns = function() {
        if($scope.expanded_table === 'true') {
            $scope.expanded_table = 'false';
        } else {
            $scope.expanded_table = 'true';
        }
    };

    $scope.formatHours = function(hours) {
        var days = 0;
        while(hours > 23) {
            days += 1;
            hours -= 23;
        };
        if(days)
          return days + ':' + moment().startOf('day').add(hours, 'hours').format('HH:mm');
        else
          return moment().startOf('day').add(hours, 'hours').format('HH:mm');
    };

    $scope.filteredMenuItem = function(item) {
        return ($scope.filtered_menu_items.indexOf(item) !== -1);
    };

    $scope.init = function() {
        $scope.expanded_table = 'false';
    	$scope.bid = BidOldReview.get();

        console.log('got the bid');

        if(!$scope.bid || !$scope.bid._id){
            $location.path('/');
            return;
        }

        $scope.my_roles.forEach(function(role) {
            if(role === 'admin' || role === 'tm_admin') {
                $scope.is_admin = true;
            } else if(role === 'mtc') {
                $scope.is_contractor = true;
            } else if(role === 'division') {
                $scope.is_division = true;
            } else if (role === 'tm') {
                $scope.is_manager = true;
            }
        });

        $scope.only_manager = false;

        if($scope.is_manager) {
            if(!($scope.is_admin || $scope.is_contractor || $scope.is_division))
                $scope.only_manager = true;
        }

        $scope.specs = [];

        $scope.bidding_trades = [];

        if($scope.is_builder) {
            Bids.query({'_id': $scope.bid._id}, function(bids) {
                if(bid.length !== 1) {
                    toaster.pop('error', 'Database', 'Could not find the bid');
                    return;
                }

                $scope.bid = bid[0];

                if($scope.bid.bidding_trades.length !== 1) {
                    toaster.pop('error', 'bidoldreview, line: 70',
                        'Cannot process bidding trades. Contact Admin');
                    $location.path('/');
                    return;
                }

                if($scope.only_manager) {
                    $scope.bid.bidding_trades.forEach(function(bid) {
                        if(bid.trade === $scope.user.trade[0]) {
                            $scope.bidding_trades.push(bid.trade);
                            $scope.specs.push({
                                trade: bid.trade,
                                inclusions: bid.inclusions,
                                exclusions: bid.exclusions
                            });
                        }
                    });

                    $scope.current_trade_selection = {};
                    $scope.current_trade_selection.trade = $scope.user.trade[0];
                } else {
                    $scope.bidding_trades.push('Total');
                    $scope.bid.bidding_trades.forEach(function(bid) {
                        $scope.bidding_trades.push(bid.trade);
                        $scope.specs.push({
                            trade: bid.trade,
                            inclusions: bid.inclusions,
                            exclusions: bid.exclusions
                        });
                    });
                    //add a specs page
                    //$scope.bidding_trades.push('Specs');
                    $scope.bidding_trades.push('Total Materials');
                    $scope.bidding_trades.push('Total Equipment');
                }

                $scope.bid_menu = [];

                var menu = $scope.bid.project_plan;

                _.each($scope.bid.plan_codes, function(plan_code) {
                    $scope.bid_menu.push({
                        item: plan_code.code
                    });
                });

                $scope.trade_totals = [];
                $scope.bid_menu.push({
                    item: 'Specs'
                });
                $scope.bid_menu.push({
                    item: 'Materials'
                });
                $scope.bid_menu.push({
                    item: 'Total Materials'
                });

                $scope.current_plan = $scope.bid_menu[0];

                $scope.bid.bidding_trades.forEach(function(bid, idx) {
                    var current_bid_trade = bid.trade;
                    $scope.trade_totals.push({
                        name: bid.name,
                        trade: bid.trade,
                        accepted: bid.accepted
                    });
                    //$scope.trade_totals[idx].plan_totals = [];

                    for(var i=0; i<bid.revisions.length; i++) {
                        $scope.revisions.push({
                            name: 'Rev: ' + bid.revisions[i].number,
                            revision: bid.revisions[i].number,
                            date: new Date(bid.revisions[i].date_completed)
                        });
                    }

                    $scope.revisions.push({
                        name: 'Current',
                        revision: $scope.revisions.length+1,
                        date: new Date(bid.date_completed)
                    });

                    $scope.selectedRevision = $scope.revisions[$scope.revisions.length-1];
                    $scope.current_trade_costs = bid.costs;
                    $scope.original_bid_list = angular.copy(bid.bid);
                    $scope.original_costs = angular.copy(bid.costs);
                    $scope.original_inclusions = angular.copy(bid.inclusions);
                    $scope.original_exclusions = angular.copy(bid.exclusions);
                    $scope.original_overrides = angular.copy(bid.overrides);
                    $scope.original_extra_liability = angular.copy(bid.extra_liability);

                    $scope.my_bid_trade = $scope.getTradeCode(current_bid_trade);

                    $scope.buildTaskBidList(bid);
                });

                $scope.calculateTotals($scope.trade_totals);
                if($scope.only_manager) {
                    $scope.updateTablePlan();
                    $scope.onSelect($scope.user.trade[0]);
                }
            });
        } else {
            userService.getMainAccount($scope.user.username).then(function(main_user) {
                TradeBids.query({'bid_id': $scope.bid._id, 'username': main_user.username}, function(trade_bid) {
                    //$scope.my_bid = trade_bid[0];

                    if(trade_bid.length !== 1) {
                        toaster.pop('error', 'Database', 'Could not find the bid');
                        return;
                    }

                    $scope.bid.bidding_trades[0] = trade_bid[0];

                    if($scope.bid.bidding_trades.length !== 1) {
                        toaster.pop('error', 'bidoldreview, line: 70',
                            'Cannot process bidding trades. Contact Admin');
                        $location.path('/');
                        return;
                    }

                    if($scope.only_manager) {
                        $scope.bid.bidding_trades.forEach(function(bid) {
                            if(bid.trade === $scope.user.trade[0]) {
                                $scope.bidding_trades.push(bid.trade);
                                $scope.specs.push({
                                    trade: bid.trade,
                                    inclusions: bid.inclusions,
                                    exclusions: bid.exclusions
                                });
                            }
                        });

                        $scope.current_trade_selection = {};
                        $scope.current_trade_selection.trade = $scope.user.trade[0];
                    } else {
                        $scope.bidding_trades.push('Total');
                        $scope.bid.bidding_trades.forEach(function(bid) {
                            $scope.bidding_trades.push(bid.trade);
                            $scope.specs.push({
                                trade: bid.trade,
                                inclusions: bid.inclusions,
                                exclusions: bid.exclusions
                            });
                        });
                        //add a specs page
                        //$scope.bidding_trades.push('Specs');
                        $scope.bidding_trades.push('Total Materials');
                        $scope.bidding_trades.push('Total Equipment');
                    }

                	$scope.bid_menu = [];

                	var menu = $scope.bid.project_plan;

                    _.each($scope.bid.plan_codes, function(plan_code) {
                        $scope.bid_menu.push({
                            item: plan_code.code
                        });
                    });

                    $scope.trade_totals = [];
                    $scope.bid_menu.push({
                        item: 'Specs'
                    });
                    $scope.bid_menu.push({
                        item: 'Materials'
                    });
                    $scope.bid_menu.push({
                        item: 'Total Materials'
                    });

                    $scope.current_plan = $scope.bid_menu[0];

                    $scope.bid.bidding_trades.forEach(function(bid, idx) {
                        var current_bid_trade = bid.trade;
                        $scope.trade_totals.push({
                            name: bid.name,
                            trade: bid.trade,
                            accepted: bid.accepted
                        });
                        //$scope.trade_totals[idx].plan_totals = [];

                        for(var i=0; i<bid.revisions.length; i++) {
                            $scope.revisions.push({
                                name: 'Rev: ' + bid.revisions[i].number,
                                revision: bid.revisions[i].number,
                                date: new Date(bid.revisions[i].date_completed)
                            });
                        }

                        $scope.revisions.push({
                            name: 'Current',
                            revision: $scope.revisions.length+1,
                            date: new Date(bid.date_completed)
                        });

                        $scope.selectedRevision = $scope.revisions[$scope.revisions.length-1];
                        $scope.current_trade_costs = bid.costs;
                        $scope.original_bid_list = angular.copy(bid.bid);
                        $scope.original_costs = angular.copy(bid.costs);
                        $scope.original_inclusions = angular.copy(bid.inclusions);
                        $scope.original_exclusions = angular.copy(bid.exclusions);
                        $scope.original_overrides = angular.copy(bid.overrides);
                        $scope.original_extra_liability = angular.copy(bid.extra_liability);

                        $scope.my_bid_trade = $scope.getTradeCode(current_bid_trade);

                        $scope.buildTaskBidList(bid);
                    });

                    $scope.calculateTotals($scope.trade_totals);
                    if($scope.only_manager) {
                        $scope.updateTablePlan();
                        $scope.onSelect($scope.user.trade[0]);
                    }
                });
            });
        }
    };

    $scope.buildTaskBidList = function(bid) {
        var bid_tasks = [];
        $scope.materials = [];
        $scope.equipment = [];
        $scope.trade_totals[0].plan_totals = [];
        $scope.MaterialTotal = 0;
        $scope.EquipmentTotal = 0;
        $scope.SalesTaxRate = $scope.current_trade_costs.sales_tax;

        //$scope.bid_menu.forEach(function(menu, mdx) {
        _.each($scope.bid_menu, function(menu, mdx) {
            if(menu.item === 'Specs') return;
            if(menu.item === 'Materials') return;
            if(menu.item === 'Total Materials') return;
            var bid_tasks = [];
            var tasks = $filter('filter')(bid.task_list, {
                'trade': $scope.my_bid_trade}, true);

            _.each(tasks, function(task) {
                task.plan = menu.item;
                task.trade_name = bid.name;

                var inlist = $filter('filter')(bid.bid, {
                    'task_id': task._id, 'plan_code': menu.item}, true);

                if(inlist.length === 1) {
                    _.each(inlist[0].subtasks, function(subtask) {
                        var sub = $filter('filter')(task.subtasks, {
                            '_id': subtask.task_id}, true);

                        if(sub.length === 1) {
                            sub[0].trade_name = bid.name;
                            sub[0].quantity = subtask.quantity;
                            sub[0].bid_hours = subtask.bid_hours;
                            sub[0].labor = subtask.labor;

                            _.each(sub[0].materials, function(material) {
                                var mat = $filter('filter')(subtask.materials, 
                                    {'material_id': material._id}, true);

                                if(mat.length === 1) {
                                    material.trade_name = bid.name;
                                    material.quantity = mat[0].quantity;
                                    material.price_per_order = mat[0].price_per_order;
                                    material.delivery_price = mat[0].delivery_price;
                                } else {
                                    material.trade_name = bid.name;
                                    material.quantity = 0;
                                    material.price_per_order = 0;
                                    material.delivery_price = 0;
                                }
                            });

                            _.each(sub[0].equipment, function(equipment) {
                                var eq = $filter('filter')(subtask.equipment, 
                                    {'equipment_id': equipment._id}, true);

                                if(eq.length === 1) {
                                    equipment.trade_name = bid.name;
                                    equipment.quantity = eq[0].quantity;
                                    equipment.price_per_order = eq[0].price_per_order;
                                    equipment.delivery_price = eq[0].delivery_price;
                                } else {
                                    equipment.trade_name = bid.name;
                                    equipment.quantity = 0;
                                    equipment.price_per_order = 0;
                                    equipment.delivery_price = 0;
                                }
                            });
                        }
                    });
                } else {
                    _.each(task.subtasks, function(subtask) {
                        subtask.trade_name = bid.name;
                        subtask.quantity = 0;
                        subtask.bid_hours = 0;
                        subtask.labor = 0;

                        _.each(subtask.materials, function(material) {
                            material.trade_name = bid.name;
                            material.quantity = 0;
                            material.price_per_order = 0;
                            material.delivery_price = 0;
                        });

                        _.each(subtask.equipment, function(equipment) {
                            equipment.trade_name = bid.name;
                            equipment.quantity = 0;
                            equipment.price_per_order = 0;
                            equipment.delivery_price = 0;
                        });
                    });
                }

                bid_tasks.push(angular.copy(task));
            });

            $scope.applayCalculations(bid_tasks, bid.name, menu);

            //if(!$scope.trade_totals[0].plan_totals)
            //  $scope.trade_totals[0].plan_totals = [];

            //var new_bid_tasks = angular.copy(bid_tasks)

            $scope.trade_totals[0].plan_totals.push(bid_tasks);
            $scope.trade_totals[0].plan_totals[mdx].plan_code = menu.item;

            _.each(bid_tasks, function(bid) {
                _.each(bid.subtasks, function(sub) {
                    _.each(sub.materials, function(mat) {
                        $scope.materials.push(angular.copy(mat));
                        $scope.materials[$scope.materials.length-1].plan_code = menu.item;
                        $scope.materials[$scope.materials.length-1].task_code = bid.trade + bid.task;
                        $scope.materials[$scope.materials.length-1].trade_name = $scope.trade_totals[0].name;
                        var tax = mat.materials_subtotal * $scope.current_trade_costs.sales_tax;
                        $scope.materials[$scope.materials.length-1].material_total = 
                            mat.materials_subtotal + tax + (mat.delivery_price * mat.quantity);
                        $scope.MaterialTotal += $scope.materials[$scope.materials.length-1].material_total;
                    });

                    //sub.equipment.forEach(function(eq) {
                    _.each(sub.equipment, function(eq) {
                        $scope.equipment.push(angular.copy(eq));
                        $scope.equipment[$scope.equipment.length-1].plan_code = menu.item;
                        $scope.equipment[$scope.equipment.length-1].task_code = bid.trade + bid.task;
                        $scope.equipment[$scope.equipment.length-1].trade_name = $scope.trade_totals[0].name;
                        var tax = eq.equipment_subtotal * $scope.current_trade_costs.equipment_tax;
                        $scope.equipment[$scope.equipment.length-1].equipment_total =
                            Number(eq.price_per_order) * Number(eq.quantity) +
                            (eq.delivery_price * eq.quantity) + tax;
                        $scope.EquipmentTotal += $scope.equipment[$scope.equipment.length-1].equipment_total;
                    });
                });
            });
        });
    };

    $scope.materialsPage = function(trade) {
        var bid_tasks = [];

        if(!$scope.bid || !$scope.bid._id){
            return;
        }
    };

    $scope.totals = [];

    $scope.calculateTotals = function(trades) {
        $scope.totals = [];
        //step through each trade
        trades.forEach(function(trade, index) {
            var plan_total = 0;
            trade.plan_totals.forEach(function(plan, idx) {
                plan_total = plan_total + plan.bid_total;
                $scope.totals.push({
                    trade: trade.trade,
                    plan: plan.plan_code,
                    total: plan.bid_total
                });
            });
            trade.plan_total = plan_total;
        });
    };

    $scope.getPlanTotals = function(item) {
        var temp = $filter('filter')($scope.totals, {plan: item}, true);
        var ret_val = 0;
        temp.forEach(function(it) {
            ret_val = ret_val + it.total;
        });

        return ret_val;
    };

    $scope.getTradeTotals = function(item) {
        var temp = $filter('filter')($scope.totals, {trade: item}, true);
        var ret_val = 0;
        temp.forEach(function(it) {
            ret_val = ret_val + it.total;
        });
        return ret_val;
    };

    $scope.getAllTotals = function() {
        var ret_val = 0;
        $scope.totals.forEach(function(it) {
            ret_val = ret_val + it.total;
        });
        return ret_val;
    };

    $scope.updateTablePlan = function() {
        $scope.bid_tasks = [];
        var current_bid_trade = [];

        var bid_trade = $scope.bid.bidding_trades[0];

        var trade_code = $scope.getTradeCode($scope.current_trade_selection.trade);
        if(!trade_code) return;
        
        var bids = $filter('filter')(bid_trade.bid, {
            'plan_code': $scope.current_plan.item}, true);
        var task_list = $filter('filter')(bid_trade.task_list, { 
            'trade': trade_code}, true);

        //first build a task_list that only has the current bid trade
        bids.forEach(function(bid_task) {
            var task = $filter('filter')(task_list, {_id: bid_task.task_id}, true);

            if(task.length !== 1) {
                console.log('There is more than one task with the task id requested ' + bid_task.task_id);
                return;
            }

            task[0].plan_code = bid_task.plan_code;

            bid_task.subtasks.forEach(function(subtask, si) {
                task[0].subtasks.forEach(function(tsub, tsi) {
                    if(subtask.task_id === tsub._id) {
                        tsub.quantity = subtask.quantity;
                        tsub.bid_hours = subtask.bid_hours;
                        tsub.labor = subtask.labor;
                    }

                    subtask.equipment.forEach(function(eq, eidx) {
                        tsub.equipment.forEach(function(teq, teidx) {
                            if(eq.equipment_id === teq._id) {
                                teq.quantity = eq.quantity;
                                if(eq.price_per_order)
                                  teq.price_per_order = eq.price_per_order;
                                if(eq.delivery_price)
                                  teq.delivery_price = eq.delivery_price;
                            }
                        });
                    });
                    subtask.materials.forEach(function(mq, midx) {
                        tsub.materials.forEach(function(tmq, tmidx) {
                            if(mq.material_id === tmq._id && tmq._id) {
                                tmq.quantity = mq.quantity;
                                if(mq.price_per_order)
                                  tmq.price_per_order = mq.price_per_order;
                                if(mq.delivery_price)
                                  tmq.delivery_price = mq.delivery_price;
                            }
                        });
                    });
                });
            });

            $scope.bid_tasks.push(task[0]);
        });

        $scope.applayCalculations($scope.bid_tasks, $scope.current_trade_selection.trade, $scope.current_plan);
    };

    $scope.onSelect = function(item) {
        console.log('in on select ' + item + $scope);
        var trade_bid = $filter('filter')($scope.trade_totals, {trade: item}, true);

        if(trade_bid.length === 0) {
            // if(item === 'Specs') {
            //     $scope.current_trade_selection = {};
            //     $scope.current_trade_selection.trade = 'Specs';
            //     return;
            // }

            if(item === 'Total Materials') {
                $scope.current_trade_selection = {};
                $scope.current_trade_selection.trade = 'Total Materials';
                return;
            }

            if(item === 'Total Equipment') {
                $scope.current_trade_selection = {};
                $scope.current_trade_selection.trade = 'Total Equipment';
                return;
            }

            if(item !== 'Total') {
                alert('there was an issue getting the totals for ' + item);
                return;
            }

            $scope.current_trade_selection = {};
            $scope.current_trade_selection.trade = 'Total';

        }

        //$scope.current_plan = $scope.bid_menu[0];

        if(trade_bid.length === 1) {
            $scope.current_trade_selection = trade_bid[0];
            $scope.selectedPlan = 0;
            $scope.updateTablePlan();
        } else if(item !== 'Total')
          alert('problem with trade bid selection ' + item);
    };

    $scope.onPlanSelect = function(item) {
        console.log('in the onSelect function ' + item.item);
        $scope.current_plan = item;
        // if($scope.current_plan.item === 'Cover') {
        //     data = [];
        //     $scope.buildBidCoverPage();
        // } else if($scope.current_plan.item === 'Materials') {
        //     data = [];
        // } else if($scope.current_plan.item === 'Equipment') {
        //     data = [];
        // } else if($scope.current_plan.item === 'Specs') {
        //     data = [];
        // } else {
            $scope.updateTablePlan();
        //}
    };

    $scope.applayCalculations = function(tasks, trade, plan) {
        //var costs = $filter('filter')($scope.bid.bidding_trades, {'name': trade}, true);
        //taskTotalsService.getTradeCalculations(tasks, trade, $scope.bid.costs);
        taskTotalsService.getCalculations(tasks, $scope.current_trade_costs);

        //$scope.bid_total = tasks.bid_total;
        $scope.bid_general_liability = tasks.bid_general_liability;
        $scope.bid_total_labor = tasks.bid_total_labor;
        $scope.bid_total_materials = tasks.bid_total_materials;
        $scope.bid_materials_taxes = tasks.bid_materials_taxes;
        $scope.bid_materials_subtotal = tasks.bid_materials_subtotal;
        $scope.bid_total_equipment = tasks.bid_total_equipment;
        $scope.bid_equipment_subtotal = tasks.bid_equipment_subtotal;
        $scope.bid_equipment_taxes = tasks.bid_equipment_taxes;
        $scope.bid_direct_labor = tasks.bid_direct_labor;
        $scope.bid_mark_up = tasks.bid_mark_up;
        $scope.bid_workers_comp = tasks.bid_workers_comp;
        $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;

        var inlist = [];

        if(tasks.length > 0) {
            //var plan = (tasks[0].plan_code)? tasks[0].plan_code: tasks[0].plan;
            inlist = $filter('filter')($scope.bid.bidding_trades[0].overrides,
                {'plan_code': plan.item}, true);
        } else {
            inlist = $filter('filter')($scope.bid.bidding_trades[0].overrides,
                {'plan_code': plan.item}, true);
        }
        
        if(inlist.length === 0) {
          $scope.bid_mark_up = tasks.bid_mark_up;
          $scope.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
        } else if(inlist.length === 1) {
            //so...we have an override here and need to adjust
            //the tasks that make up this plan to remove the amounts
            //until it is made up for
            var total_adjust = inlist[0].original_amount - inlist[0].amount;
            for(var i=0; i<tasks.length; i++) {
                if(tasks[i].bid_mark_up <= total_adjust) {
                    total_adjust -= tasks[i].bid_mark_up;
                    tasks[i].bid_mark_up = 0;
                } else {
                    tasks[i].bid_mark_up -= total_adjust;
                    total_adjust = 0;
                    break;
                }
            }

            tasks.bid_mark_up = inlist[0].amount;
            tasks.bid_overhead_and_profit = inlist[0].amount;
            tasks.bid_total -= inlist[0].original_amount - inlist[0].amount;
        }

        if(tasks.length > 1) {
            //var plan = (tasks[0].plan_code)? tasks[0].plan_code: tasks[0].plan;
            inlist = $filter('filter')($scope.bid.bidding_trades[0].extra_liability,
                {'plan_code': plan.item}, true);
        } else {
            inlist = $filter('filter')($scope.bid.bidding_trades[0].extra_liability,
                {'plan_code': plan.item}, true);
        }

        $scope.bid_total = tasks.bid_total;

        if(inlist && inlist.length === 1) {
            tasks.bid_general_liability += inlist[0].amount;
            //$scope.bid_total += inlist[0].amount;
            tasks.bid_total = tasks.bid_total_labor + tasks.bid_total_materials +
                tasks.bid_total_equipment + tasks.bid_general_liability + tasks.bid_mark_up;
            $scope.bid_total = tasks.bid_total;
        }

        $scope.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
        $scope.bid_total_hours_allowed = tasks.bid_total_hours_allowed;
        $scope.bid_direct_labor = tasks.bid_direct_labor;
        //$scope.bid_total = tasks.bid_total;
    };

    $scope.getTradeCode = function(trade) {
        return tradeCodeService.getCode(trade);
    };

    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };

    $scope.changeRevision = function() {
        if($scope.selectedRevision.name === 'Current') {
            $scope.bid.bidding_trades[0].bid = $scope.original_bid_list;
            $scope.bid.bidding_trades[0].costs = $scope.original_costs;
            $scope.bid.bidding_trades[0].inclusions = $scope.original_inclusions;
            $scope.bid.bidding_trades[0].exclusions = $scope.original_exclusions;
            $scope.bid.bidding_trades[0].overrides = $scope.original_overrides;
            $scope.bid.bidding_trades[0].extra_liability = $scope.original_extra_liability;
        } else {
            $scope.bid.bidding_trades[0].bid = 
                $scope.bid.bidding_trades[0].revisions[$scope.selectedRevision.revision-1].bid;
            $scope.bid.bidding_trades[0].costs = 
                $scope.bid.bidding_trades[0].revisions[$scope.selectedRevision.revision-1].costs;
            $scope.bid.bidding_trades[0].inclusions = 
                $scope.bid.bidding_trades[0].revisions[$scope.selectedRevision.revision-1].inclusions;
            $scope.bid.bidding_trades[0].exclusions = 
                $scope.bid.bidding_trades[0].revisions[$scope.selectedRevision.revision-1].exclusions;
            $scope.bid.bidding_trades[0].overrides = 
                $scope.bid.bidding_trades[0].revisions[$scope.selectedRevision.revision-1].overrides;
            $scope.bid.bidding_trades[0].extra_liability = 
                $scope.bid.bidding_trades[0].revisions[$scope.selectedRevision.revision-1].extra_liability;
        }

        $scope.current_trade_costs = $scope.bid.bidding_trades[0].costs;
        $scope.trade_totals[0].plan_totals = [];
        $scope.current_plan = $scope.bid_menu[0];
        // this.selectedPlan = 0;
        // this.selectedIndex = 0;

        $scope.buildTaskBidList($scope.bid.bidding_trades[0]);

        $scope.calculateTotals($scope.trade_totals);
        $scope.updateTablePlan();
        $scope.updateSpecs();
    };

    $scope.updateSpecs = function() {
        $scope.specs = [];
        $scope.bid.bidding_trades.forEach(function(bid) {
            $scope.specs.push({
                trade: bid.trade,
                inclusions: bid.inclusions,
                exclusions: bid.exclusions
            });
        });
    };

    $scope.regenerateBidData = function() {
        if(!$scope.is_admin) return;
        console.log('in regenerateBidData');

        Projects.query({'name': $scope.bid.project_name}, function(projects) {
            if(projects.length !== 1) {
                toaster.pop('error', 'Project Information', 
                    'Could not get the project.  Contact Admin.');
                return;
            }

            var view_obj = {
                bid_general_liability: 0,
                bid_total_labor: 0,
                bid_total_materials: 0,
                bid_materials_taxes: 0,
                bid_materials_subtotal: 0,
                bid_total_equipment: 0,
                bid_equipment_subtotal: 0,
                bid_equipment_taxes: 0,
                bid_direct_labor: 0,
                bid_mark_up: 0,
                bid_workers_comp: 0,
                bid_payroll_taxes: 0,
                bid_overhead_and_profit: 0,
                bid_total: 0
            }

            projectBidService.buildProjectBidsFromPlans(
                projects[0]._id, 
                $scope.bid.bidding_trades[0], 
                projects[0].plan_codes,
                view_obj);
        });
    };

    $scope.savePlanTotalsToProject = function() {
        if(!$scope.is_admin) return;
        console.log('in savePlanTotalsToProject');

        Projects.query({'_id': $scope.bid.project_id}, function(projects) {
            if(projects.length !== 1) {
                toaster.pop('error', 'Project Information', 
                    'Could not get the project.  Contact Admin.');
                return;
            }

            var project = projects[0];

            //this is to fix project revisions and should be taken 
            //out after fixing up the bad projects.
            // _.each(project.trades[0].revisions, function(rev, itr) {
            //     rev.number = itr + 1;
            // });
            
            _.each($scope.revisions, function(rev) {
                $scope.selectedRevision = rev;
                $scope.changeRevision(); //update new revision totals
                _.each($scope.totals, function(total) {
                    var item = $filter('filter')(project.plan_codes, {'item': total.plan}, true);

                    if(item.length !== 1) {
                        toaster.pop('error', 'Error Finding Plan Code', 'Contact Admin');
                        return;
                    }

                    _.remove(item[0].trade_totals, function(total) {
                        return total.revision === 0;
                    });

                    var revision = rev.revision;

                    var trade_details = $filter('filter')(item[0].trade_totals, {
                        'trade': $scope.user.trade[0], 'revision': revision }, true);

                    if(trade_details.length === 0) {
                        item[0].trade_totals.push({ 
                            trade: total.trade,
                            total: total.total,
                            revision: revision
                        });
                    } else if(trade_details.length === 1) {
                        trade_details[0].total = total.total;
                    } else {
                        //too many trade totals for this revision, 
                        //remove all and set to one.
                        var rmv = _.remove(item[0].trade_totals, function(item) {
                            return item.trade === $scope.user.trade[0] &&
                                item.revision === revision;
                        });

                        item[0].trade_totals.push({ 
                            trade: total.trade,
                            total: total.total,
                            revision: revision
                        });
                    }
                    item[0].total = total.total;
                });
            });

            //console.log(project);
            project.$update(function(success) {
                toaster.pop('success', 'Project Database Updated');
            }, function(error) {
                toaster.pop('error', 'Project Update Error', error);
            });
        });
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/bids/public/controllers/bidoldreview.js